module.exports = __webpack_public_path__ + "static/media/personal_folder_slider_phone1.f74f8553.png";